"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalDesignToken = void 0;
class GlobalDesignToken {
    constructor({ name, fallback }) {
        this.namespace = '--veeam-uikit';
        this.name = `${this.namespace}-${name}`;
        this.fallback = fallback;
    }
    getVar(overrideFallback) {
        const fallback = overrideFallback !== null && overrideFallback !== void 0 ? overrideFallback : this.fallback;
        return `var(${this.name}${fallback ? `, ${fallback}` : ''})`;
    }
    getName() {
        return this.name;
    }
    static createTokens(config, prefixName = '') {
        return Object.keys(config).reduce((acc, tokenName) => {
            const designTokenLike = config[tokenName];
            acc[tokenName] = new this({
                name: `${prefixName ? `${prefixName}-` : ''}${tokenName
                    .replace(/([a-z])([A-Z])/g, '$1-$2')
                    .toLowerCase()}`,
                fallback: typeof designTokenLike === 'string'
                    ? designTokenLike
                    : `${designTokenLike.value}`
            });
            return acc;
        }, {});
    }
}
exports.GlobalDesignToken = GlobalDesignToken;
//# sourceMappingURL=GlobalDesignToken.js.map